import { Input, Component } from '@angular/core';

@Component({
  selector: 'sx-progress-bar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.css']
})
export class ProgressBarComponent {
  @Input() progreso: any;
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/progressBar/progressbar.component.ts